module.exports = __webpack_public_path__ + "static/media/havecard-3.d0cf7318.svg";